import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x48800000 {
  logLevel: number;
}

export function Command0x48800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    logLevel: 0,
  };

  const [fields, setFields] = React.useState<Form0x48800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x48800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.logLevel) {
      params.logLevel = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          // inputProps={{ min: 0, max: 2 }}
          id="logLevel"
          label="Режим логирования"
          margin="dense"
          fullWidth
          value={fields.logLevel}
          onChange={handleChangeField("logLevel")}
          helperText="0-нет логов, 1-минимальные, 2-полные"
        />
      </FormControl>
    </>
  );
}
